import styled from 'styled-components';

const Root = styled.div `
  flex: 1;
  padding: 12px 24px;

  overflow: auto;
`;

export { Root };
//# sourceMappingURL=styled.js.map
